import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AuthPreferences {
  email?: string
  countryCode?: string
  countryIsoCode?: string
  number?: string
  signInMethod?: 'email' | 'phone'
}

interface AuthPreferencesStore {
  email?: string
  countryCode?: string
  countryIsoCode?: string
  number?: string
  signInMethod?: 'email' | 'phone'
  setAuthPreferences: (preferences: AuthPreferences) => void
  clearAuthPreferences: () => void
}

export const useAuthPreferencesStore = create<AuthPreferencesStore>()(
  persist(
    (set) => ({
      email: undefined,
      countryCode: undefined,
      countryIsoCode: undefined,
      number: undefined,
      signInMethod: undefined,

      setAuthPreferences: (preferences: AuthPreferences) =>
        set((state) => ({
          ...state,
          ...preferences,
        })),

      clearAuthPreferences: () =>
        set({
          email: undefined,
          countryCode: undefined,
          countryIsoCode: undefined,
          number: undefined,
          signInMethod: undefined,
        }),
    }),
    {
      name: 'auth-preferences',
      // In web environment, use localStorage
      storage: {
        getItem: (name) => {
          const str = localStorage.getItem(name)
          return str ? JSON.parse(str) : null
        },
        setItem: (name, value) => {
          localStorage.setItem(name, JSON.stringify(value))
        },
        removeItem: (name) => localStorage.removeItem(name),
      },
    },
  ),
)
